import { render, staticRenderFns } from "./ModifierGroups.vue?vue&type=template&id=ceaff7b8&scoped=true"
import script from "./ModifierGroups.vue?vue&type=script&lang=js"
export * from "./ModifierGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceaff7b8",
  null
  
)

export default component.exports